<template>

    <div class="dropzone-container">

        <p class="explicacion">Estos documentos serán respectivamente el calendario que el/la estudiante deba
            cumplimentar semanalmente, y el modelo de Anexo 7.</p>

        <p class="explicacion">¡Atención! La práctica no podrá darse como validada hasta que no hayas aportado este
            modelo.</p>

        <div class="contenedor-input" v-if="!showcalendario">

            <h4>
                Modelo calendario
                <popup-info :texto="'calendario'" :side="'left'"></popup-info>
            </h4>
            <div class="dropzone row-start">

                <div class="text row-start">
                    <span class="upload-icon-wrapper">
                        <upload-icon v-if="!!!data.plantillaCalendario.ficheroB64" class="tag-icon"></upload-icon>
                        <success-icon v-else></success-icon>
                    </span>
                    <p v-if="!!!data.plantillaCalendario.ficheroB64" :style="styles.colorMediumBlack">Arrasta tu archivo o haz click
                        para adjuntar (Imagen o PDF)</p>
                    <p v-else :style="styles.colorMediumBlack">{{nombreArchivo}}</p>
                </div>
                <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event,'plantillaCalendario')"
                    v-validate="`size:20000000|mimes:${formatosPermitidos}`"
                    :class="[{'has-error' : errors.has('file')}]" />
                <span class='error'>{{ errors.first('file') }}</span>

            </div>

        </div>



        <div class="contenedor-input" v-if="!showplantilla">

            <h4>
                Modelo Anexo 7
                <popup-info :texto="'anexo_7'" :side="'left'"></popup-info>
            </h4>
            <div class="dropzone row-start">

                <div class="text row-start">
                    <span class="upload-icon-wrapper">
                        <upload-icon v-if="!!!data.plantillaAnexo7.ficheroB64" class="tag-icon"></upload-icon>
                        <success-icon v-else></success-icon>
                    </span>
                    <p v-if="!!!data.plantillaAnexo7.ficheroB64" :style="styles.colorMediumBlack">Arrasta tu archivo o haz click
                        para adjuntar (Imagen o PDF)</p>
                    <p v-else :style="styles.colorMediumBlack">{{nombreArchivo}}</p>
                </div>
                <input type="file" id="file" name="file" ref="file" @change="handleFileUpload($event,'plantillaAnexo7')"
                    v-validate="`size:20000000|mimes:${formatosPermitidos}`"
                    :class="[{'has-error' : errors.has('file')}]" />
                <span class='error'>{{ errors.first('file') }}</span>

            </div>

        </div>

        <a class="btn" :style="styles.solidPrimary" @click="sendData" :loading="loading">Enviar</a>

    </div>

</template>



<script>

    import { mapGetters,mapActions } from 'vuex';

    import uploadicon from '@/components/parts/icons/upload';
    import successicon from '@/components/parts/icons/success';

    import popupinfo from '@/components/parts/popup-info';

    export default {
        name: "adjunto-cf",
        props : ['showcalendario','showplantilla','id'],
        mounted(){
            this.data.idOferta = this.id;
        },
        data: () => ({
            formatosPermitidos: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/msword', 'image/*'],
            data: {
                "idOferta": '',
                "plantillaAnexo7": {
                    "ficheroB64": "",
                    "extension_adjunto": ""
                },
                "plantillaCalendario": {
                    "ficheroB64": "",
                    "extension_adjunto": ""
                }
            },
            loading : false
        }),
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                dominios: 'getDominios',
                brand: 'getBrand'
            }),
        },
        methods: {
            ...mapActions(['subirAdjuntosOferta']),
            handleFileUpload(event, value) {

                this.$validator.validate('file')
                    .then(itsOk => {
                        if (itsOk) {
                            let file = event.target.files[0];
                            this.nombreArchivo = file.name;
                            this.data[value].extension_adjunto = file.type.split("/")[1];
                            this.getBase64(file).then(data => {
                                console.log(value);
                                this.data[value].ficheroB64 = data;
                            });
                        }
                    });
            },
            getBase64: function (file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            sendData(){
                this.$validator.validateAll().then(itsOk => {
                    if (itsOk) {
                        this.loading = true;
                        this.subirAdjuntosOferta(this.data).then(r => {
                            if(r){
                                this.$emit('refresh')
                            }
                            this.loading = false;
                        })
                    }
                });
            }
        },
        components: {
            'upload-icon': uploadicon,
            'success-icon': successicon,
            'popup-info' : popupinfo
        }
    }
</script>

<style lang="scss" scoped>
    .dropzone {
        width: 100%;
        min-height: 50px;
        background: #f2f2f2;
        padding: 20px;
        position: relative;
    }

    .dropzone svg {
        width: 30px;
        height: 30px;
        filter: grayscale(1);
        opacity: .5
    }

    .dropzone input {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 3;
    }

    .dropzone .text {
        width: 100%;
    }

    .dropzone p {
        text-align: center;
        font-size: 14px;
        color: #333;
        margin-left: 20px;
        margin-bottom: 0;
        width: auto;
    }

    .dropzone span.error {
        bottom: -24px;
    }

    .explicacion {
        text-align: left;
        font-size: 14px;
        margin-bottom: 10px;
        font-style: italic;
    }

    .dropzone-container {
        margin-top: 30px;
    }

    h4 {
        font-weight: 600;
        text-align: left;
        margin-bottom: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/adjunto-oferta-cf.vue